import {
	Button,
	Card,
	CardBody,
	Content,
	ContentVariants,
	EmptyState,
	EmptyStateFooter,
	Icon,
	Title,
} from "@patternfly/react-core";
import type { FC, ReactElement } from "react";
import { useProductMetadata } from "../../hooks/useProductMetadata";
import { validateAttachedProjects } from "../../utils/attachedProjectValidator";
import "./VVCertStatus.scss";
import { CheckIcon } from "@patternfly/react-icons";
import { useHistory } from "react-router-dom";
import Env from "../../utils/env";

export const VVCertStatus: FC = () => {
	const {
		productDetail,
		activeCertificationListState,
		isProductPartnerValidated,
		componentMetadata: { hasValidated, isCertifiedProduct },
	} = useProductMetadata();
	const history = useHistory();
	const isValidated = hasValidated || isProductPartnerValidated;
	const isProductCertified =
		validateAttachedProjects(productDetail, activeCertificationListState, false) && isCertifiedProduct;
	const getHeader = (): ReactElement => {
		if (isValidated && !isProductCertified) {
			return (
				<Title headingLevel={"h3"} className="vv-or-cert">
					<Icon isInline>
						<CheckIcon />
					</Icon>
					&nbsp;&nbsp;Validated
				</Title>
			);
		} else if (isProductCertified) {
			return (
				<Title headingLevel={"h3"} className="vv-or-cert">
					<Icon isInline>
						<CheckIcon />
					</Icon>
					&nbsp;&nbsp;Certified
				</Title>
			);
		} else {
			return (
				<Title headingLevel={"h3"} className="no-vv-or-cert">
					Not Validated or Certified
				</Title>
			);
		}
	};

	const getFooter = (): ReactElement => {
		let buttonText = "Start validation or certification";

		if (isValidated && !isProductCertified) {
			buttonText = "Manage validations and certifications";
		} else if (isProductCertified) {
			buttonText = "Manage certifications";
		}

		return (
			<Button
				onClick={() => history.push(`${Env.routePrefix}/products/${productDetail?._id}/validations-and-certifications`)}
				variant="primary"
			>
				{buttonText}
			</Button>
		);
	};
	return (
		<Card isCompact className="vv-cert-status" isFullHeight={true}>
			<CardBody>
				<Content>
					<Content component={ContentVariants.h2}>Validation/Certification Status</Content>
				</Content>
				<EmptyState titleText={getHeader()}>
					<EmptyStateFooter>{getFooter()}</EmptyStateFooter>
				</EmptyState>
			</CardBody>
		</Card>
	);
};
